export const BRANDED_TERM_TYPES = {
  BN: "BN",
  SBDF: "SBDF",
  SBDC: "SBDC",
  SBD: "SBD"
};

export const NOT_BRANDED_TERM_TYPES = {
  PIN: "PIN",
  SCDF: "SCDF",
  SCDC: "SCDC",
  SCD: "SCD"
};

export const TERM_TYPES = {
  ...NOT_BRANDED_TERM_TYPES,
  ...BRANDED_TERM_TYPES
};
export const DOSE_FORM_CATEGORY_TYPES = [
  { key: "0", value: "isInfusion", text: "infusion" },
  { key: "1", value: "isSubcutaneous", text: "subcutaneous" },
  { key: "2", value: "isOralOrOther", text: "oral_and_others" }
];
